// extracted by mini-css-extract-plugin
export var problems__description = "problems-module--problems__description--78921";
export var problems__img = "problems-module--problems__img--ce707";
export var problems__imgOne = "problems-module--problems__img--one--703a0";
export var problems__imgThree = "problems-module--problems__img--three--eaa79";
export var problems__imgTwo = "problems-module--problems__img--two--5b2af";
export var problems__item = "problems-module--problems__item--5768f";
export var problems__list = "problems-module--problems__list--365e1";
export var problems__name = "problems-module--problems__name--9be43";
export var problems__text = "problems-module--problems__text--4d6f2";
export var problems__title = "problems-module--problems__title--a9959";